/* src/app/shared/components/history/history.component.scss */
.operation_history {
  font-size: 80%;
  color: grey;
  display: flex;
  justify-content: flex-end;
}
.history-user {
  margin-left: 0.3rem;
  margin-right: 1rem;
}
.history-updated {
  margin-left: 0.3rem;
}
/*# sourceMappingURL=history.component-CD6WZJY3.css.map */
